import { toast } from "react-toastify";
import logger from "./logger";

export interface StateType {
  loading: boolean;
  error: string | null;
  qrCode: string | null;
  showQrCode: boolean;
  status: string | null;
  [key: string]: any;
}

export const connectWebSocket = (
  WEBSOCKET_URL: string,
  onMessage: (event: MessageEvent) => void,
  onError: (event: Event) => void,
  onClose?: (this: WebSocket, ev: CloseEvent) => any,
  onOpen?: () => void,
): WebSocket | null => {
  const socket = new WebSocket(WEBSOCKET_URL);

  socket.onmessage = onMessage;
  socket.onerror = onError;
  socket.onclose = onClose || null;

  socket.onopen = onOpen || (() => {});

  return socket;
};

export const handleWebSocketMessage = <T extends StateType>(
  event: MessageEvent,
  setState: React.Dispatch<React.SetStateAction<T>>,
  toastMessage: string,
  onSuccessCallback?: () => void,
) => {
  try {
    const message = event.data.startsWith("i")
      ? { qrCodeBase64: event.data, status: "SCAN_QR_CODE" }
      : JSON.parse(event.data);

    if (message.status === "SCAN_QR_CODE") {
      setState((prevState) => ({
        ...prevState,
        qrCode: "data:image/png;base64," + message.qrCodeBase64,
        showQrCode: true,
        webSocketLoading: false,
        loading: false,
        status: "SCAN_QR_CODE",
      }));
    } else if (message.status === "WORKING") {
      setState((prevState) => ({
        ...prevState,
        showQrCode: false,
        webSocketLoading: false,
        loading: false,
        status: "WORKING",
      }));

      toast.success(toastMessage);

      // Execute callback immediately to update sessions without delay
      if (onSuccessCallback) {
        onSuccessCallback();
      }
    }
  } catch (error) {
    logger.error("[WebSocket] Failed to parse WebSocket message:", error);
  }
};

export const handleWebSocketError = <T extends StateType>(
  event: Event,
  setState: React.Dispatch<React.SetStateAction<T>>,
  errorMessage: string,
) => {
  logger.error("WebSocket error observed:", event);
  setState((prevState) => ({
    ...prevState,
    webSocketLoading: false,
    loading: false,
    error: errorMessage,
  }));
};

export const handleWebSocketClose = (
  socket: WebSocket | null,
  onClose?: (this: WebSocket, ev: CloseEvent) => any,
): void => {
  if (socket) {
    socket.onclose = onClose || (() => {});

    if (
      socket.readyState === WebSocket.OPEN ||
      socket.readyState === WebSocket.CONNECTING
    ) {
      socket.close();
    }
  }
};
